<template>
  <div class="app-wrapper" v-bind:class="{ closed: menu_opened }">

    <SideNavigation @menu-toggled="menu_toggled"/>

    <div class="wrapper">
      <TopNavigation/>
      Security ins
    </div>
  </div>
  
</template>

<script>
import TopNavigation from '@/components/navigation/Top_navigation'
import SideNavigation from '@/components/navigation/Side_navigation'
export default {
  components: {
    TopNavigation,
    SideNavigation
  },
  data() {
    return {
      menu_opened: false,
    }
  },
  methods: {
    menu_toggled() {this.menu_opened = !this.menu_opened} 
  }
}
</script>

<style>

</style>